import EmberService from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class FlowDemoService extends EmberService {
	@tracked numberOfOnboardingSourceStepVisits = 0;
}

declare module '@ember/service' {
	interface Registry {
		'flow/demo': FlowDemoService;
	}
}
